import { ChannelType } from "./ChannelType";
import catalog from "../../ConceptOne/src/data/C1_EloItemCatalog.json";

const legacyLightChannels: Record<string, ChannelType> = {
  switch: ChannelType.Switch,
  dimmable: ChannelType.Dimmer,
  tunable_white: ChannelType.TuneableWhite,
  rgb: ChannelType.Rgb,
  rgbw: ChannelType.Rgb,
};

/** Repairs former fallback channels using fixed device defaults from the catalog. */
export function migratedDoorEquipmentChannelType(definitionPath: string | undefined): ChannelType | undefined {
  const definitionId = definitionPath?.split("/").pop();
  if (!definitionId) return undefined;
  const definition = (catalog.items as Record<string, {
    type?: string;
    defaultDetails?: { channelType?: string };
    details?: { channelType?: unknown };
  }>)[definitionId];
  if (!definition || definition.type === "light" || definition.details?.channelType) return undefined;
  const channelType = definition.defaultDetails?.channelType;
  return Object.values(ChannelType).find((value) => value === channelType);
}

/** Converts the former C1 light function into the shared consumer properties. */
export function migrateConsumerDetails<T extends { channelType?: ChannelType; isDali?: boolean }>(details: T): T {
  const legacy = details as T & { lightType?: string };
  if (!legacy.lightType) return details;
  const { lightType, ...rest } = legacy;
  return {
    ...rest,
    channelType: details.channelType ?? legacyLightChannels[lightType.replace(/_dali$/, "")] ?? ChannelType.Switch,
    isDali: details.isDali ?? lightType.endsWith("_dali"),
  } as T;
}
